// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';

const ControlButtons = ({
  history,
  submit,
}) => {
  const cancel = (event) => {
    event.preventDefault();
    history.goBack();
  };

  const handlerSave = async event => {
    event.preventDefault();
    submit('createWorkOrderTemplateReduxForm');
  };

  return (
    <div className="create_actions">
      <button
        type="button"
        className="dashboard-btn dashboard-btn--secondary"
        aria-label="cancel"
        onClick={cancel}
      >
        Cancel
      </button>
      <button
        type="button"
        name="save"
        className="dashboard-btn dashboard-btn--primary"
        aria-label="save"
        onClick={handlerSave}
      >
        Save
      </button>
    </div>
  );
};

const mapDispatchToProps = {
  submit,
};

export default connect(null, mapDispatchToProps)(ControlButtons);
